export default function PreviewTopSectionDialogController(
  ssDialogService,
) {
  const vm = this;
  vm.handleClose = _handleClose;

  /** **************************************************
   * Event Handlers
   */

  function _handleClose() {
    _closeDialog();
  }

  /** **************************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.pm.previewTopSectionDialog);
  }
}

PreviewTopSectionDialogController.$inject = [
  'ssDialogService',
];
